let alldata = {
  index: {
    navarr: [{
      id: 1,
      name: '首页',
      url: '/home'
    },
    // {
    //   id: 2,
    //   name: '产品介绍',
    //   url: '/product'
    // },
    {
      id: 3,
      name: '业务招募',
      url: '/business'
    },
    {
      id: 4,
      name: '下载中心',
      url: '/download'
    },
    {
      id: 5,
      name: '教程',
      url: '/Course'
    },
      // {
      //   id: 6,
      //   name: '品牌定制',
      //   url: '/brand'
      // },
    ],
    //底部服务
    servicearr: [{
      id: 1,
      name: '7x24小时服务支撑'
    },
    {
      id: 2,
      name: '装完即跑 快速赚钱'
    },
    {
      id: 3,
      name: '产品多样化'
    },
    {
      id: 4,
      name: '1v1客户专享服务'
    },
    ],
    //底部二维码
    qrarr: [
      {
        id: 1,
        name: '官方交流群',
        img: 'https://oss.jinchaoshuju.com/images/985616d2-2a62-4e69-977b-2528cf7072af.png'
      },
      {
        id: 2,
        name: '上机商务1',
        img: 'https://oss.jinchaoshuju.com/images/8b71384e-a136-4ee3-8c0e-54faf5935f3a.png'
      },
      {
        id: 3,
        name: '上机商务2',
        img: 'https://oss.jinchaoshuju.com/images/0032a4e2-ac6f-4385-ad2d-5d3581c40c9d.png'
      },
      {
        id: 4,
        name: '上机商务3',
        img: 'https://oss.jinchaoshuju.com/images/a50b6fb1-7a4d-4419-ae06-5d361c995bcc.png'
      },
      {
        id: 5,
        name: '上机商务4',
        img: 'https://oss.jinchaoshuju.com/images/5a2b6fd1-71e3-48c2-a4b1-09d5ba93361d.png'
      },
    ],
  },
  // },//首页数据
  product: {
    bannerarr: [{
      id: 1,
      name: '多元化智能硬件',
      value: '闲置带宽、存储和算力的共享边缘计算运营平台',
      img: require('../assets/product/banner2.jpg')
    },], //产品banner图数据
    productarr: [

      {
        id: 1,
        title: 'OES',
        value: '性能升级 | 全民共享',
        value2: '',
        list: [{
          value: '百万节点 全新旗舰',
          iconimg: require('../assets/product/icon1.png')
        },
        {
          value: '性能升级 功耗更低',
          iconimg: require('../assets/product/icon2.png')
        },
        {
          value: '灵便轻巧 轻松装盘',
          iconimg: require('../assets/product/icon3.png')
        },
        {
          value: '千兆网络 最优选择',
          iconimg: require('../assets/product/icon4.png')
        }
        ],
        img: require('../assets/product/工控机.png')
      },
      {
        id: 2,
        title: 'OEC',
        value: '赋能边缘算力，同创科技价值',
        value2: '高性能 | 高收益 | 低能耗',
        list: [{
          value: '硬件升级 强化性能',
          iconimg: require('../assets/product/icon1.png')
        },
        {
          value: '超低功耗 绿色节约',
          iconimg: require('../assets/product/icon2.png')
        },
        {
          value: '带宽拓展 收益加倍',
          iconimg: require('../assets/product/icon3.png')
        },
        {
          value: '轻松管理 乐享收益',
          iconimg: require('../assets/product/icon4.png')
        }
        ],
        img: require('../assets/product/盒子.png'),
      },
      {
        id: 3,
        title: '玩客云',
        value: '畅快下载的私人云盘',
        value2: '全新一代共享计算智能硬件',
        list: [{
          value: '高速下载',
          iconimg: require('../assets/product/icon1.png')
        },
        {
          value: '手机扩容',
          iconimg: require('../assets/product/icon2.png')
        },
        {
          value: '多屏互动',
          iconimg: require('../assets/product/icon3.png')
        },
        {
          value: '隐私加密',
          iconimg: require('../assets/product/icon4.png')
        }
        ],
        img: require('../assets/product/净化器.png')
      },
      {
        id: 4,
        title: '赚钱宝',
        value: '让你的路由器能“赚钱”',
        value2: '',
        list: [{
          value: '4核CPU',
          iconimg: require('../assets/product/icon1.png')
        },
        {
          value: '256M RAM+ 1G ROM',
          iconimg: require('../assets/product/icon2.png')
        },
        {
          value: '操作简单 轻松接入',
          iconimg: require('../assets/product/icon3.png')
        },
        {
          value: '共享闲置带宽与存储资源',
          iconimg: require('../assets/product/icon4.png')
        }
        ],
        img: require('../assets/product/路由器.png')
      },
      {
        id: 4,
        title: '赚钱宝',
        value: '让你的路由器能“赚钱”',
        value2: '',
        list: [{
          value: '4核CPU',
          iconimg: require('../assets/product/icon1.png')
        },
        {
          value: '256M RAM+ 1G ROM',
          iconimg: require('../assets/product/icon2.png')
        },
        {
          value: '操作简单 轻松接入',
          iconimg: require('../assets/product/icon3.png')
        },
        {
          value: '共享闲置带宽与存储资源',
          iconimg: require('../assets/product/icon4.png')
        }
        ],
        img: require('../assets/product/路由器.png')
      },
      {
        id: 5,
        title: '赚钱宝',
        value: '让你的路由器能“赚钱”',
        value2: '',
        list: [{
          value: '4核CPU',
          iconimg: require('../assets/product/icon1.png')
        },
        {
          value: '256M RAM+ 1G ROM',
          iconimg: require('../assets/product/icon2.png')
        },
        {
          value: '操作简单 轻松接入',
          iconimg: require('../assets/product/icon3.png')
        },
        {
          value: '共享闲置带宽与存储资源',
          iconimg: require('../assets/product/icon4.png')
        }
        ],
        img: require('../assets/product/路由器组装.png')
      },
      {
        id: 6,
        title: '赚钱宝',
        value: '让你的路由器能“赚钱”',
        value2: '',
        list: [{
          value: '4核CPU',
          iconimg: require('../assets/product/icon1.png')
        },
        {
          value: '256M RAM+ 1G ROM',
          iconimg: require('../assets/product/icon2.png')
        },
        {
          value: '操作简单 轻松接入',
          iconimg: require('../assets/product/icon3.png')
        },
        {
          value: '共享闲置带宽与存储资源',
          iconimg: require('../assets/product/icon4.png')
        }
        ],
        img: require('../assets/product/摄像头.png')
      },
      {
        id: 7,
        title: '赚钱宝',
        value: '让你的路由器能“赚钱”',
        value2: '',
        list: [{
          value: '4核CPU',
          iconimg: require('../assets/product/icon1.png')
        },
        {
          value: '256M RAM+ 1G ROM',
          iconimg: require('../assets/product/icon2.png')
        },
        {
          value: '操作简单 轻松接入',
          iconimg: require('../assets/product/icon3.png')
        },
        {
          value: '共享闲置带宽与存储资源',
          iconimg: require('../assets/product/icon4.png')
        }
        ],
        img: require('../assets/product/摄像头1.png')
      },
    ],//产品列表
  },//产品介绍
  business: {
    businessarr: [
      {
        id: 1, title: 'V聚合业务', value: '多线聚合，节省资源',
        img: require('../assets/icons/1.png'),
        iconcolor: '#FAC37E'
      },
      {
        id: 2, title: '定向业务', value: '定向业务下发，调度稳定',
        img: require('../assets/icons/3.png'),
        iconcolor: '#01C567'
      },
      {
        id: 3, title: '小水管业务', value: '单线单机，简单上手',
        img: require('../assets/icons/2.png'),
        iconcolor: '#667CFA'
      },
      {
        id: 5, title: '更多业务', value: '极客首选，自由编排',
        img: require('../assets/icons/5.png'),
        iconcolor: '#999999'
      },

    ],
  },//业务招募

}
export default alldata;
